import { render, staticRenderFns } from "./MenuCta.vue?vue&type=template&id=0a76584e&"
import script from "./MenuCta.vue?vue&type=script&lang=ts&"
export * from "./MenuCta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports